module.exports = __webpack_public_path__ + "img/next360-rounded-sm.72e6c218.svg";